import type { ComponentType } from "react";
import { AuthPage } from "../pages/auth";
import { JoinPage } from "../pages/join";
import { HomePage } from "../pages/home";
import { RsvpPage } from "../pages/rsvp";
import { GalleryPage } from "../pages/gallery";
import { UploadPage } from "../pages/upload";
import { SlideshowPage } from "../pages/slideshow";

/**
 * `/:slug` altındaki misafir rotalarının TEK kaynağı.
 *
 * Admin/organizer'daki tam `nav-registry` kararı BİLEREK alınmadı — web'de
 * sidebar/badge/outsideLayout mantığı yok, o yüzden burada yalnız üç alan var:
 * segment + korumalı mı + element.
 *
 * İki şeyi birden çözer:
 *  1. **B3** — `App.tsx` ve `__tests__/route-resolution.test.tsx` artık AYNI
 *     listeden türüyor; segment listesi ikiye ayrılıp sapamıyor. Önceden
 *     `paths.ts` → `App.tsx` → test ÜÇÜ de elle senkron tutuluyordu.
 *  2. **B4 (import-time patlaması)** — bu dosya her sayfa modülünü statik import
 *     ettiği için, test onu import ettiği AN yedi sayfanın da import-time
 *     güvenliği kanıtlanır (bir sayfanın modül seviyesinde patlaması testi
 *     kırar). admin/organizer'da `nav-registry.ts`'in sağladığı mekanizmanın
 *     aynısı — orada zaten kapalıydı, web'de açıktı.
 */
export interface WeddingRouteSegment {
  /** `/:slug` altındaki göreli segment; `undefined` = index rotası. */
  routePath?: string;
  /** `true` → `ProtectedRoute` + `Layout` içinde mount edilir. */
  protected: boolean;
  element: ComponentType;
}

export const WEB_WEDDING_ROUTES: WeddingRouteSegment[] = [
  { routePath: "auth", protected: false, element: AuthPage },
  { routePath: "join", protected: false, element: JoinPage },
  { routePath: undefined, protected: true, element: HomePage },
  { routePath: "rsvp", protected: true, element: RsvpPage },
  { routePath: "gallery", protected: true, element: GalleryPage },
  { routePath: "upload", protected: true, element: UploadPage },
  { routePath: "slideshow", protected: true, element: SlideshowPage },
];

/** Auth/join gibi giriş gerektirmeyen rotalar — `Layout`'un DIŞINDA. */
export const WEB_PUBLIC_WEDDING_ROUTES = WEB_WEDDING_ROUTES.filter((r) => !r.protected);

/** Giriş gerektiren rotalar — `ProtectedRoute` + `Layout` İÇİNDE. */
export const WEB_PROTECTED_WEDDING_ROUTES = WEB_WEDDING_ROUTES.filter((r) => r.protected);

/**
 * `demo` rotaları BİLEREK bu listede DEĞİL: `/:slug` altında değiller (üst
 * seviyede, `/demo/:variant`), düğün context'i gerektirmiyorlar ve yalnız iki
 * sabit satırlar. Listeye alınmaları `WeddingRouteSegment`'in anlamını bozardı.
 */
